angular.module('unica_archive_admin.archive_admin_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		.state('app.archive_admin', {
			url: '/archive-admin/:event_id',
			views: {
				'mainContent': {
					templateUrl: './modules/archive-admin/templates/archive-admin.html',
					controller: 'ArchiveAdminController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Archivio Admin',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
				}
			}
		});

});

